import {
    makeStyles,
    tokens,
    shorthands,
    GriffelStyle,
} from '@fluentui/react-components';

const makeStatusIndicatorStyles = (
    statusStyles: Record<string, GriffelStyle>
): GriffelStyle => {
    return {
        display: 'inline-block',
        height: tokens.spacingHorizontalXS,
        width: tokens.spacingHorizontalXS,
        marginRight: tokens.spacingHorizontalXS,
        ...shorthands.borderRadius('50%'),
        ...statusStyles,
    };
};

export const useDepartureBoardPageStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
    },
    selectedRowsButton: {
        display: 'flex',
        alignItems: 'center',
        ...shorthands.gap(tokens.spacingHorizontalXS),
    },
    table: {
        marginTop: tokens.spacingVerticalM,
        overflow: 'auto',
        height: 'fit-content',
    },
    tableRow: {
        justifyContent: 'space-between',
        height: '44px',
        minWidth: 'fit-content',
        ...shorthands.padding(0, tokens.spacingHorizontalXL),
    },
    tableSelectionCell: {
        minWidth: '25px',
        maxWidth: '25px',
    },
    departureStatusIndicator: makeStatusIndicatorStyles({
        '&.OnTime': {
            backgroundColor: tokens.colorPaletteLightGreenForeground3,
        },
        '&.Departed': {
            backgroundColor: 'transparent',
        },
        '&.Delayed': {
            backgroundColor: tokens.colorPaletteYellowForeground3,
        },
        '&.Cancelled': {
            backgroundColor: tokens.colorPaletteRedForeground3,
        },
    }),
    statusIndicator: makeStatusIndicatorStyles({
        '&.Yes': {
            backgroundColor: tokens.colorPaletteLightGreenForeground3,
        },
        '&.No': {
            backgroundColor: tokens.colorPalettePlatinumBackground2,
        },
        '&.NotAvailable': {
            backgroundColor: tokens.colorPalettePlatinumBackground2,
        },
        '&.AllNotified': {
            backgroundColor: tokens.colorPaletteLightGreenForeground3,
        },
        '&.NotNotified': {
            backgroundColor: tokens.colorPaletteRedForeground3,
        },
        '&.OutstandingActions': {
            backgroundColor: tokens.colorPaletteRedForeground3,
        },
    }),
    connectionStatusIndicator: makeStatusIndicatorStyles({
        '&.None': {
            backgroundColor: tokens.colorPalettePlatinumBackground2,
        },
        '&.New': {
            backgroundColor: tokens.colorPalettePlatinumBackground2,
        },
        '&.Established': {
            backgroundColor: tokens.colorPaletteLightGreenForeground3,
        },
        '&.Closed': {
            backgroundColor: tokens.colorPalettePlatinumBackground2,
        },
        '&.Error': {
            backgroundColor: tokens.colorPaletteRedForeground3,
        },
    }),
    status: {
        display: 'flex',
        alignItems: 'center',
    },
    filtersContainer: {
        display: 'flex',
        flexDirection: 'column',
        maxWidth: '250px',
    },
    filtersHeader: {
        alignSelf: 'flex-end',
    },
    filters: {
        display: 'flex',
        flexDirection: 'column',
        rowGap: tokens.spacingVerticalS,
    },
    filter: {
        display: 'grid',
        gridRowGap: tokens.spacingVerticalXS,
    },
});
